import veritoneApi from './veritoneApi';
import _ from 'lodash';
import { DEFAULT_MENTION_STATUS_IDS } from '../components/Watchlist/api';

export const STATION_DEFAULT_SOURCE_TYPE_IDS = [1, 2];
export const STATION_DEFAULT_PERMISSION = 'viewer';

const GET_STATION = (sourceTypeIds, limit, offset) => `
    {
        sources(
          sourceTypeIds: ${JSON.stringify(sourceTypeIds)},
          permission: viewer,
          limit: ${limit}, 
          offset: ${offset},
          includePublic: false,
        ) {
          records {
            id
            name
            sourceTypeId
          }
          count
        }
    }`;

const GET_STATIONS_BY_IDS = (stationIds) => `
    {
        ${stationIds.map(id =>`
          station_${id}:
          sources(
            sourceTypeIds: ${DEFAULT_MENTION_STATUS_IDS},
            permission: viewer,
            includePublic: false,
            id: ${id}
          ) {
              records {
              id,
              name,
              details
            }
          },
          `)}
    }`;

function genGetOrgStationQuery(limit, offset) {
  return `
  {
    sources(
      sourceTypeIds: ${JSON.stringify(STATION_DEFAULT_SOURCE_TYPE_IDS)},
      permission: ${STATION_DEFAULT_PERMISSION},
      limit: ${limit},
      offset: ${offset},
      includePublic: false) {
      records {
        id
        name
        sourceTypeId
        details
      }
      count
    }
  }`
}

export function getListStationApi(urlApi, sourceTypeIds, limit, offset) {
    return veritoneApi(urlApi.graphql).post('', { query: GET_STATION(sourceTypeIds, limit, offset) })
        .then(response => _.get(response, 'data.data.sources.records', []))
        .catch(error => [])
}

export function getStationsByIds(urlApi, stationIds = []){
    if (stationIds.length === 0) {
      return [];
    }
    return veritoneApi(urlApi.graphql).post('', { query: GET_STATIONS_BY_IDS(stationIds) })
      .then(response => {
        const data = _.get(response, 'data.data', {});
        const records = [];
        for (const stationKey in data) {
          const record = _.get(data[stationKey], 'records[0]')
          if (record) {
            records.push(record)
          }
        }
        return records;
      })
      .catch(error => error)
}

export async function getOrgStationsApi(urlApi, index = 0, limit = 100) {
  try {
    const response = await veritoneApi(urlApi.graphql).post(
      '',
      { query: genGetOrgStationQuery(limit, index) }
    );
    const { error } = response;
    if (error) {
      return { error };
    }

    const stations = _.get(response, 'data.data.sources.records', []);
    if ( stations.length === limit ) {
      const newIndex = index + limit;
      const moreStations = await getOrgStationsApi(urlApi, newIndex, limit );
      const newStationList = [...stations, ...moreStations.data];
      return { data: newStationList };
    } else {
      return { data: stations };
    }
  } catch (error) {
    return { error };
  }
}

export function getStationAvailabilityApi(urlApi, stationIds) {
  return veritoneApi(urlApi.baseUrl)
  .post(`/markets/availability_station`, stationIds)
  .then(response => response.data)
  .catch(error => error);
}
